export default [
  {
    path: '/engine/modules/:id',
    name: 'engine-module-edit',
    component: () => import('./index.vue'),
    props: route => ({
      moduleId: route.params.id,
      initialType: route.query.type || '',
      initialTable: route.query.table || '',
      standalone: true,
    }),
    meta: { engine: true, requiresAdmin: true },
  },
  {
    path: '/engine/modules/:id/variants/:variant',
    name: 'engine-module-variant-edit',
    component: () => import('./editVariant.vue'),
    props: route => ({
      moduleId: route.params.id,
      variant: route.params.variant,
      standalone: true,
    }),
    meta: { engine: true, requiresAdmin: true },
  },
]
